import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class AddressEvaluatorService {
	public evaluateForPOBox(address: string): boolean {
		return /\b[P|p]*(OST|ost)*\.*\s*[O|o|0]*(ffice|FFICE)*\.*\s*[B|b][O|o|0][X|x]\b/.test(address);
	}

	public evaluateForRestrictedState(state: string): boolean {
		return state.toLowerCase() === 'ak' || state.toLowerCase() === 'hi';
	}
}
